import { render, staticRenderFns } from "./LogoItem.vue?vue&type=template&id=f4633c2a&scoped=true&"
import script from "./LogoItem.vue?vue&type=script&lang=js&"
export * from "./LogoItem.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/LogoItem/LogoItem.less?vue&type=style&index=0&id=f4633c2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4633c2a",
  null
  
)

export default component.exports